import { Component, ElementRef, Injector, OnInit, inject, viewChild } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { jkLib } from 'jk-service';
import { AdvComModule, jkQueryComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';

@Component({
  selector: 'app-stkpq16',
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
  templateUrl: './stkpq16.component.html',
  styleUrl: './stkpq16.component.css'
})
export class Stkpq16Component extends jkQueryComponent implements OnInit {
  override _programId = 'stkpq16'; // ###
  readonly fileInput = viewChild.required<ElementRef>('fileInput');
  dateA: string = jkLib.nowDate();
  dateB: string = jkLib.nowDate();
  //pageOpt: PageOption= new PageOption(this.programId + '_page'); //###
  //filterOpt: FilterOption = new FilterOption(this.programId); //###
  csvContent: string = '';
  constructor() {
    super();
    this.setFormOpt2(); //###
  }
  openFileDialog() {
    this.fileInput().nativeElement.click();
  }
  processArrayBuffer(arrayBuffer: ArrayBuffer) {
    let uint8Array = new Uint8Array(arrayBuffer);
    let big5Buffer = new TextDecoder('big5').decode(uint8Array);// 變空白了
    console.log(big5Buffer);
    this.csvContent = big5Buffer;
  }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const arrayBuffer = e.target?.result as ArrayBuffer;
        this.processArrayBuffer(arrayBuffer);
        /*
        const uint8Array = new Uint8Array(arrayBuffer);
        let big5Buffer = new TextDecoder('big5').decode(uint8Array);
        //const decodedString = iconv.decode(uint8Array, 'big5');
                // 將 Big5 字串轉換為 Buffer
        //const big5Buffer = Buffer.from(arrayBuffer, 'binary');

        // 使用 iconv-lite 將 Big5 轉換為 UTF-8
        //this.csvContent = iconv.decode(big5Buffer, 'big5');
        // 将字符串转换为 Buffer，假设它是 Big5 编码
        //let big5Buffer = Buffer.from(arrayBuffer as any, 'binary');

        // 使用 iconv-lite 进行编码转换
        this.csvContent = iconv.decode(Buffer.from(big5Buffer, 'binary'), 'big5');
        */
        this.doCalcDateRange(this.csvContent);
      };
      reader.readAsText(file);
    }
  }
  onValueChangeA($event: string) {
    this.dateA = $event;
  }
  onValueChangeB($event: string) {
    this.dateB = $event;
  }
  doCalcDateRange(csvContent: string) {
    //...
    let date1 = '29991231';
    let date2 = '00000000';
    let list = csvContent.split('\n');
    for (let i = 0; i < list.length; i++) {
      let obj = this.xqCsv2Obj(list[i]);
      if (obj['日期'] < date1) {
        date1 = obj['日期'];
      }
      if (obj['日期'] > date2) {
        date2 = obj['日期'];
      }
    }
    this.dateA = date1;
    this.dateB = date2;
  }
}
